import { useTranslation } from 'react-i18next';
import { ReactComponent as MBLogo } from '../../../Assets/Images/logo.svg';
import { ReactComponent as LinkedInIcon } from '../../../Assets/Images/linkedin.svg';
import { ReactComponent as KununuIcon } from '../../../Assets/Images/kununu.svg';
import rootList from '../../../Constants/footerList';
import './Footer.scss';

function Footer() {
	const { t, i18n } = useTranslation();
	const isEnglish = (i18n.language?.split('-')[0] || 'en') === 'en';

	return (
		<div className="footer">
			<div className="footer__inner">
				<div className="footer__brand">
					<div className="footer__brand-logo" data-testid="footer-logo">
						<MBLogo className="footer__brand-logo-svg" aria-label="Mercedes-Benz" />
					</div>
				</div>
				<div className="footer__divider" />
				<div className="footer__bottom">
					<span className="footer__copyright" data-testid="footer-copyright">
						{t('mainScreen.footer.copyright')}
					</span>
					<nav className="footer__links">
						{rootList.map((e) => {
							const isExternal = /^https?:\/\//.test(e.url);
							return (
								<a
									key={e.key}
									className="footer__link"
									href={e.url}
									rel={isExternal ? 'noopener noreferrer' : undefined}
									target={isExternal ? '_blank' : undefined}
								>
									{t(`mainScreen.footer.${e.value}`)}
								</a>
							);
						})}
					</nav>
					<div className="footer__right">
						<div className="footer__lang-switcher">
							<button
								type="button"
								className={`footer__lang-btn${isEnglish ? ' footer__lang-btn--active' : ''}`}
								onClick={() => i18n.changeLanguage('en')}
								data-testid="footer-lang-en"
							>
								EN
							</button>
							<button
								type="button"
								className={`footer__lang-btn${!isEnglish ? ' footer__lang-btn--active' : ''}`}
								onClick={() => i18n.changeLanguage('de')}
								data-testid="footer-lang-de"
							>
								DE
							</button>
						</div>
						<a
							className="footer__social-icon"
							href={t('mainScreen.footer.linkedinUrl')}
							rel="noopener noreferrer"
							target="_blank"
							aria-label="LinkedIn"
							data-testid="footer-social-linkedin"
						>
							<LinkedInIcon className="footer__social-svg" aria-hidden="true" />
						</a>
						<a
							className="footer__social-icon"
							href={t('mainScreen.footer.kununuUrl')}
							rel="noopener noreferrer"
							target="_blank"
							aria-label="Kununu"
							data-testid="footer-social-kununu"
						>
							<KununuIcon className="footer__social-svg" aria-hidden="true" />
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Footer;
